/* ── Lomban Hydropower Project — Landowner Clan / Subclan / Family structure ── */

export const CLAN_DATA = [
  {
    id:       "kaiyaul",
    name:     "Kaiyaul Clan",
    tribe:    "Awain Tribe",
    location: "Western bank, Lai River",
    subclans: [
      {
        id:       "milikin",
        name:     "Milikin Subclan",
        families: [
          "Abal","Angopae","Elisha","Irai","Kiponge","Lamb","Lau","Lyamb",
          "Neayak","Paen","Paki","Pimbik","Puio","Sairos","Tangupae",
          "Yakaly","Yakan","Yangun","Yongapen",
        ],
      },
      {
        id:       "kandelyo",
        name:     "Kandelyo Subclan",
        families: ["Kaik","Kemb","Kolalyo","Lemb"],
      },
    ],
  },
  {
    id:       "piau",
    name:     "Piau Clan",
    tribe:    "Yanaitin Tribe",
    location: "Eastern bank, Lai River",
    subclans: [
      {
        id:       "kumun",
        name:     "Kumun Subclan",
        families: ["Lum","Yapari"],
      },
      {
        id:       "yaki",
        name:     "Yaki Subclan",
        families: [
          "Aipingi","Husukun","Iki","Kakale","Karao","Kiyakaen",
          "Komba","Korakan","Nalakau","Nallao","Polyan","Yakinarae","Yapok",
        ],
      },
      {
        id:       "piole",
        name:     "Piole Subclan",
        families: [
          "Eyakan","Henry","Kepakan","Lipai","Mailyo","Mendokon",
          "Pakau","Puki","Talikin","Timbai",
        ],
      },
    ],
  },
];

/** Flat list of every {family, subId, subName, clanId, clanName} */
export const ALL_FAMILIES = CLAN_DATA.flatMap(c =>
  c.subclans.flatMap(s =>
    s.families.map(f => ({
      family:   f,
      subId:    s.id,
      subName:  s.name,
      clanId:   c.id,
      clanName: c.name,
    }))
  )
);

/** 2 clans · 5 subclans · 48 families */
export const TOTAL_FAMILIES = ALL_FAMILIES.length;

/** Look up clan/subclan lineage for a family name */
export function familyLineage(family) {
  return ALL_FAMILIES.find(f => f.family === family) ?? null;
}
